import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const VisionSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="section-padding bg-charcoal-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-16">
            <p className="text-gold text-xs uppercase tracking-[0.2em] sm:tracking-[0.3em] mb-3 sm:mb-4">
              {t.vision.tagline}
            </p>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-cream leading-tight mb-4 sm:mb-6 px-2">
              {t.vision.headline}
            </h2>
            <div className="gold-divider" />
          </div>

          {/* Vision Content */}
          <div className="text-center mb-10 sm:mb-16 px-2">
            {t.vision.content.map((paragraph, index) => (
              <p 
                key={index} 
                className={`text-cream-300 leading-relaxed mb-4 sm:mb-6 ${
                  index === 0 ? 'text-xl sm:text-2xl lg:text-3xl font-serif text-cream italic' : 'text-base sm:text-lg'
                }`}
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* Principles Grid - 2 columns on mobile */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
            {t.vision.principles.map((principle, index) => (
              <div key={index} className="text-center p-4 sm:p-6 border border-white/10 hover:border-gold/30 transition-colors rounded-xl">
                <h4 className="font-serif text-base sm:text-lg text-gold mb-2 sm:mb-3">
                  {principle.title}
                </h4>
                <p className="text-cream-400 text-xs sm:text-sm leading-relaxed">
                  {principle.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;